import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers, withKeys as _withKeys, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_clipboard.svg'
import _imports_1 from '@/app/ui/assets/svg/delete.svg'
import _imports_2 from '@/app/ui/assets/svg/plus-active.svg'
import _imports_3 from '@/app/ui/assets/svg/ics_f_info_circle_dark_blue.svg'
import _imports_4 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-3c726b18")

_pushScopeId("data-v-3c726b18")
const _hoisted_1 = { class: "bg-white border border-gray-lp-1400 rounded-xl p-3 text-xs text-gray-lp-300" }
const _hoisted_2 = { class: "flex flex-row items-center gap-2" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "w-5 h-5",
  src: _imports_0,
  alt: "clipboard"
}, null, -1)
const _hoisted_4 = { class: "font-semibold" }
const _hoisted_5 = { class: "py-3" }
const _hoisted_6 = { class: "border border-gray-lp-2100 rounded-md border-separate w-full" }
const _hoisted_7 = { class: "text-left" }
const _hoisted_8 = /*#__PURE__*/_createVNode("th", { class: "ml-3 mr-6 py-2 font-semibold w-7 border-b border-gray-lp-2100" }, " No ", -1)
const _hoisted_9 = {
  class: "mr-6 py-2 font-semibold border-b border-gray-lp-2100",
  style: {"width":"519px"}
}
const _hoisted_10 = {
  class: "mr-6 py-2 font-semibold border-b border-gray-lp-2100",
  style: {"width":"100px"}
}
const _hoisted_11 = {
  class: "mr-6 py-2 font-semibold border-b border-gray-lp-2100",
  style: {"width":"190px"}
}
const _hoisted_12 = /*#__PURE__*/_createVNode("th", {
  class: "py-2 font-semibold border-b border-gray-lp-2100",
  style: {"width":"73px"}
}, null, -1)
const _hoisted_13 = { class: "mt-4" }
const _hoisted_14 = { class: "w-full flex flex-row justify-between items-center" }
const _hoisted_15 = { class: "flex flex-row ml-1" }
const _hoisted_16 = {
  key: 0,
  class: "bg-yellow-lp-200 rounded text-center text-yellow-lp-100 font-medium text-xs px-1"
}
const _hoisted_17 = {
  key: 1,
  class: "ml-1 bg-red-lp-600 rounded text-center text-red-lp-1600 font-medium text-xs px-1"
}
const _hoisted_18 = { class: "flex flex-row ml-1" }
const _hoisted_19 = {
  key: 0,
  class: "bg-yellow-lp-200 rounded text-center text-yellow-lp-100 font-medium text-xs px-1"
}
const _hoisted_20 = {
  key: 1,
  class: "ml-1 bg-red-lp-600 rounded text-center text-red-lp-1600 font-medium text-xs px-1"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "plus",
  style: {"width":"18px","height":"18px"}
}, null, -1)
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  class: "px-3 py-1.5 border-t border-gray-lp-2100",
  colspan: "5"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("img", {
  class: "w-5 h-5",
  src: _imports_2,
  alt: "plus"
}, null, -1)
const _hoisted_25 = { class: "flex flex-row gap-3" }
const _hoisted_26 = { class: "w-1/2 flex flex-col gap-3" }
const _hoisted_27 = { class: "flex flex-row items-center font-semibold" }
const _hoisted_28 = { class: "relative" }
const _hoisted_29 = { class: "tooltip-content" }
const _hoisted_30 = {
  key: 0,
  class: "p-1 mt-1 bg-blue-lp-600 flex gap-x-1 rounded-md"
}
const _hoisted_31 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  alt: "info-blue"
}, null, -1)
const _hoisted_32 = { class: "text-12px font-medium text-blue-lp-700" }
const _hoisted_33 = {
  id: "supporting-document-wrapper",
  class: "rounded-lg border border-gray-lp-1400 p-3 w-1/2 flex flex-col",
  style: {}
}
const _hoisted_34 = { class: "flex flex-row items-center justify-between" }
const _hoisted_35 = { class: "text-gray-lp-600" }
const _hoisted_36 = { class: "flex flex-row items-end justify-between" }
const _hoisted_37 = {
  key: 0,
  class: "flex flex-row items-center gap-2"
}
const _hoisted_38 = /*#__PURE__*/_createVNode("img", {
  src: _imports_4,
  class: "w-4.5 max-w-none",
  alt: "exclamation tiangle red"
}, null, -1)
const _hoisted_39 = { class: "text-sm text-red-lp-1200" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_UploadImageTiny = _resolveComponent("UploadImageTiny")!
  const _component_ModalAllCommodity = _resolveComponent("ModalAllCommodity")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("section", _hoisted_1, [
      _createVNode("section", _hoisted_2, [
        _hoisted_3,
        _createVNode("h1", _hoisted_4, _toDisplayString(_ctx.getTranslationText("title")), 1)
      ]),
      _createVNode("section", _hoisted_5, [
        _createVNode(_component_DataWrapper, {
          class: "text-xs",
          label: _ctx.getTranslationText('CIPLLabel'),
          optional: !_ctx.isOtherCommodityRequired,
          isDefault: false
        }, null, 8, ["label", "optional"]),
        _createVNode("table", _hoisted_6, [
          _createVNode("thead", null, [
            _createVNode("tr", _hoisted_7, [
              _hoisted_8,
              _createVNode("th", _hoisted_9, _toDisplayString(_ctx.getTranslationText("itemDetailCIPLHeadingText")), 1),
              _createVNode("th", _hoisted_10, _toDisplayString(_ctx.getTranslationText("quantityCIPLHeadingText")), 1),
              _createVNode("th", _hoisted_11, _toDisplayString(_ctx.getTranslationText("itemPriceCIPLHeadingText")), 1),
              _hoisted_12
            ])
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listCommodityCIPL, (cipl, index) => {
            return (_openBlock(), _createBlock("tr", {
              key: cipl.id,
              class: "list-complete-item"
            }, [
              _createVNode("td", {
                class: ["pl-3 pr-6", _ctx.decideBorderBottomTableColumn(index)]
              }, [
                _createVNode("div", _hoisted_13, _toDisplayString(index + 1), 1)
              ], 2),
              _createVNode("td", {
                class: ["pr-6", _ctx.decideBorderBottomTableColumn(index)]
              }, [
                (!!_ctx.error.listCommodityCIPLDocInternational[index])
                  ? (_openBlock(), _createBlock(_component_SelectSearch, {
                      key: 0,
                      ref: `inputCommodity${index}`,
                      id: `select_search_komoditas_${_ctx.id}`,
                      class: "mt-1.5",
                      options: _ctx.commodities,
                      isLoading: _ctx.isLoadingCommodity,
                      keyName: "name",
                      keyValue: "code",
                      placeholder: _ctx.getTranslationText('commodityPlaceholder'),
                      modelValue: cipl.commodity,
                      "onUpdate:modelValue": [($event: any) => (cipl.commodity = $event), ($event: any) => (_ctx.validateCIPLCommodity(index))],
                      isShowErrorIndicator: 
                !!_ctx.decideShowError(
                  _ctx.error.listCommodityCIPLDocInternational[index][0],
                  cipl.indexCommodity
                )
              ,
                      errorCaption: 
                _ctx.decideShowError(
                  _ctx.error.listCommodityCIPLDocInternational[index][0],
                  cipl.indexCommodity
                )
              ,
                      maxHeight: "270px",
                      useInfiniteScroll: "",
                      idInput: "commodity-booking",
                      autoUpDown: "",
                      isViewAll: "",
                      serverSide: false,
                      onClickViewAll: ($event: any) => (_ctx.clickViewAll(index)),
                      onScrolled: _ctx.fetchCommodityListInfiniteScroll,
                      onChange: ($event: any) => (_ctx.changeCommodities($event, index)),
                      onFocus: ($event: any) => (_ctx.onFocusCommodityList(index, cipl.indexCommodity)),
                      onFilter: ($event: any) => (_ctx.handleInputCommodity($event, index)),
                      isDisabled: _ctx.getRuleTFtzCiplDisabled || _ctx.getRuleTInterCiplDisabled,
                      disabledBackground: 
                _ctx.getRuleTFtzCiplDisabled || _ctx.getRuleTInterCiplDisabled
              ,
                      notClearValue: true
                    }, {
                      "custom-option": _withId(({ item }) => [
                        _createVNode("div", _hoisted_14, [
                          _createVNode("div", null, _toDisplayString(_ctx.accountIsNonForeign ? item.name : item.nameEn), 1),
                          _createVNode("div", _hoisted_15, [
                            (item.isQuarantine)
                              ? (_openBlock(), _createBlock("span", _hoisted_16, " K "))
                              : _createCommentVNode("", true),
                            (item.isDangerousGoods)
                              ? (_openBlock(), _createBlock("span", _hoisted_17, " DG "))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      "selected-info": _withId(({ selected }) => [
                        _createVNode("div", _hoisted_18, [
                          (selected && selected.isQuarantine)
                            ? (_openBlock(), _createBlock("span", _hoisted_19, " K "))
                            : _createCommentVNode("", true),
                          (selected && selected.isDangerousGoods)
                            ? (_openBlock(), _createBlock("span", _hoisted_20, " DG "))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["id", "options", "isLoading", "placeholder", "modelValue", "onUpdate:modelValue", "isShowErrorIndicator", "errorCaption", "onClickViewAll", "onScrolled", "onChange", "onFocus", "onFilter", "isDisabled", "disabledBackground"]))
                  : _createCommentVNode("", true)
              ], 2),
              _createVNode("td", {
                id: "cipl-quantity-wrapper",
                class: ["pr-6", _ctx.decideBorderBottomTableColumn(index)]
              }, [
                (!!_ctx.error.listCommodityCIPLDocInternational[index])
                  ? (_openBlock(), _createBlock(_component_lp_input, {
                      key: 0,
                      id: "cipl-quantity",
                      class: "cipl-quantity",
                      format: _ctx.formatCIPLQuantityNomorOnly,
                      modelValue: cipl.quantity,
                      "onUpdate:modelValue": [($event: any) => (cipl.quantity = $event), ($event: any) => (_ctx.validateCIPLQuantity(index))],
                      placeholder: "0",
                      error: 
                !!_ctx.decideShowError(
                  _ctx.error.listCommodityCIPLDocInternational[index][1],
                  cipl.indexQuantity
                )
              ,
                      "error-caption": 
                _ctx.decideShowError(
                  _ctx.error.listCommodityCIPLDocInternational[index][1],
                  cipl.indexQuantity
                )
              ,
                      onFocus: ($event: any) => (_ctx.updateFIeldIndex(cipl.indexQuantity)),
                      disabled: _ctx.getRuleTFtzCiplDisabled || _ctx.getRuleTInterCiplDisabled,
                      disableBackground: 
                _ctx.getRuleTFtzCiplDisabled || _ctx.getRuleTInterCiplDisabled
              
                    }, null, 8, ["format", "modelValue", "onUpdate:modelValue", "error", "error-caption", "onFocus", "disabled", "disableBackground"]))
                  : _createCommentVNode("", true)
              ], 2),
              _createVNode("td", {
                id: "cipl-goods-price-wrapper",
                class: ["pr-6", _ctx.decideBorderBottomTableColumn(index)]
              }, [
                (!!_ctx.error.listCommodityCIPLDocInternational[index])
                  ? (_openBlock(), _createBlock(_component_lp_input, {
                      key: 0,
                      id: "cipl-goods-price",
                      class: "cipl-goods-price",
                      placeholder: "0",
                      modelValue: cipl.goodsPrice,
                      "onUpdate:modelValue": [($event: any) => (cipl.goodsPrice = $event), ($event: any) => (_ctx.validateCIPLGoodsPrice(index))],
                      format: _ctx.formatCIPLGoodsPrice,
                      prefix: 
                _ctx.isEditSttMY || !_ctx.accountIsNonForeign ? 'RM' : _ctx.getTranslationText('goodsPricePrefix')
              ,
                      error: 
                !!_ctx.decideShowError(
                  _ctx.error.listCommodityCIPLDocInternational[index][2],
                  cipl.indexGoodsPrice
                )
              ,
                      "error-caption": 
                _ctx.decideShowError(
                  _ctx.error.listCommodityCIPLDocInternational[index][2],
                  cipl.indexGoodsPrice
                )
              ,
                      onFocus: ($event: any) => (_ctx.updateFIeldIndex(cipl.indexGoodsPrice)),
                      onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"])),
                      disabled: _ctx.getRuleTFtzCiplDisabled || _ctx.getRuleTInterCiplDisabled,
                      disableBackground: 
                _ctx.getRuleTFtzCiplDisabled || _ctx.getRuleTInterCiplDisabled
              
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "format", "prefix", "error", "error-caption", "onFocus", "disabled", "disableBackground"]))
                  : _createCommentVNode("", true)
              ], 2),
              _createVNode("td", {
                class: ["pr-6", _ctx.decideBorderBottomTableColumn(index)]
              }, [
                _withDirectives(_createVNode("button", {
                  class: "text-red-lp-100 font-semibold flex flex-row gap-2 items-center mt-4",
                  onClick: () => _ctx.onDeleteCIPL(index)
                }, [
                  _hoisted_21,
                  _createTextVNode(" " + _toDisplayString(_ctx.getTranslationText("deleteCIPLBtnText")), 1)
                ], 8, ["onClick"]), [
                  [_vShow, 
                _ctx.listCommodityCIPL.length > 1 &&
                  !_ctx.getRuleTFtzCiplDisabled &&
                  !_ctx.getRuleTInterCiplDisabled
              ]
                ])
              ], 2)
            ]))
          }), 128)),
          (
            _ctx.listCommodityCIPL.length < _ctx.MAX_CIPL &&
              !_ctx.getRuleTFtzCiplDisabled &&
              !_ctx.getRuleTInterCiplDisabled
          )
            ? (_openBlock(), _createBlock("tr", _hoisted_22, [
                _createVNode("td", _hoisted_23, [
                  _createVNode("button", {
                    class: "text-red-lp-100 font-semibold flex flex-row gap-2 items-center",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onAddCIPL && _ctx.onAddCIPL(...args)))
                  }, [
                    _hoisted_24,
                    _createTextVNode(" " + _toDisplayString(_ctx.getTranslationText("addCIPLBtnText")), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("section", _hoisted_25, [
        _createVNode("section", _hoisted_26, [
          (_ctx.isDutyTaxTermsRequired)
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 0,
                class: "text-xs",
                id: "doc-international-select-duty-tax-terms-wrapper"
              }, {
                label: _withId(() => [
                  _createVNode("div", _hoisted_27, [
                    _createTextVNode(_toDisplayString(_ctx.getTranslationText('dutyTaxTermsLabel')) + " ", 1),
                    _createVNode("div", _hoisted_28, [
                      _createVNode("img", {
                        src: require(`@/app/ui/assets/svg/info.svg`),
                        class: "ml-1 h-4 xxl:h-5 cursor-pointer",
                        alt: "info",
                        onMouseenter: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleTooltip($event))),
                        onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (_ctx.hideTooltip($event)))
                      }, null, 40, ["src"]),
                      _createVNode(_component_OverlayPanel, {
                        id: "duty-tax-terms-tooltip-container",
                        ref: "duty-tax-terms-tooltip",
                        class: "duty-tax-terms-tooltip-container",
                        alignOverlay: "",
                        horizontalAlign: "center",
                        style: _ctx.tooltipStyle
                      }, {
                        default: _withId(() => [
                          _createVNode("ul", _hoisted_29, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dutyTaxTermsTooltipContent, (content, index) => {
                              return _withDirectives((_openBlock(), _createBlock("li", { key: index }, null, 512)), [
                                [_directive_sanitize_html, content]
                              ])
                            }), 128))
                          ])
                        ]),
                        _: 1
                      }, 8, ["style"])
                    ])
                  ])
                ]),
                default: _withId(() => [
                  _createVNode(_component_CustomDropdown, {
                    id: "doc-international-select-duty-tax-terms",
                    isDisabled: _ctx.isRetail ? true : _ctx.getRuleTInterDutyTaxTermsDisabled,
                    disableBackground: _ctx.getRuleTInterDutyTaxTermsDisabled,
                    options: _ctx.isRetail ? _ctx.dutyTaxTermsSingleOptions : _ctx.dutyTaxTermsOptions,
                    selectedItem: _ctx.modelValue.dutyTaxTerms,
                    isFocusable: true,
                    preventUnselect: "",
                    onSelect: _ctx.onSelectDutyTaxTerms
                  }, null, 8, ["isDisabled", "disableBackground", "options", "selectedItem", "onSelect"]),
                  (_ctx.modelValue.dutyTaxTerms)
                    ? (_openBlock(), _createBlock("div", _hoisted_30, [
                        _hoisted_31,
                        _withDirectives(_createVNode("p", _hoisted_32, null, 512), [
                          [_directive_sanitize_html, _ctx.infobarDescription]
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_DataWrapper, {
            class: "text-xs",
            label: _ctx.getTranslationText('emailLabel'),
            id: "doc-international-input-wrapper",
            optional: !_ctx.isEmailRequred
          }, {
            default: _withId(() => [
              _createVNode(_component_LpInput, {
                id: "doc-international-input",
                class: "w-full",
                placeholder: _ctx.getTranslationText('emailPlaceholder'),
                modelValue: _ctx.modelValue.email,
                "onUpdate:modelValue": [
                  _cache[5] || (_cache[5] = ($event: any) => (_ctx.modelValue.email = $event)),
                  _ctx.validateEmail
                ],
                maxLength: 100,
                error: !!_ctx.decideShowError(_ctx.error.emailDocInternational, _ctx.indexEmail),
                "error-caption": 
              _ctx.decideShowError(_ctx.error.emailDocInternational, _ctx.indexEmail)
            ,
                onFocus: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateFIeldIndex(_ctx.indexEmail))),
                disabled: _ctx.getRuleTFtzEmailDisabled || _ctx.getRuleTInterEmailDisabled,
                disableBackground: 
              _ctx.getRuleTFtzEmailDisabled || _ctx.getRuleTInterEmailDisabled
            
              }, null, 8, ["placeholder", "modelValue", "error", "error-caption", "onUpdate:modelValue", "disabled", "disableBackground"])
            ]),
            _: 1
          }, 8, ["label", "optional"]),
          _createVNode(_component_DataWrapper, {
            class: "text-xs",
            label: _ctx.getTranslationText('idNumberLabel'),
            id: "doc-international-input-wrapper",
            optional: !_ctx.isIdentityNumberRequired
          }, {
            default: _withId(() => [
              _createVNode(_component_LpInput, {
                id: "doc-international-input",
                class: "w-full",
                modelValue: _ctx.modelValue.idNumber,
                "onUpdate:modelValue": [
                  _cache[7] || (_cache[7] = ($event: any) => (_ctx.modelValue.idNumber = $event)),
                  _ctx.validateIdNumber
                ],
                format: _ctx.isFtz ? _ctx.formatNomorOnly : _ctx.formatCIPLQuantity,
                placeholder: _ctx.getTranslationText('idNumberPlaceholder'),
                maxLength: 100,
                error: 
              !!_ctx.decideShowError(_ctx.error.idNumberDocInternational, _ctx.indexIdNumber)
            ,
                errorCaption: 
              _ctx.decideShowError(_ctx.error.idNumberDocInternational, _ctx.indexIdNumber)
            ,
                onFocus: _cache[8] || (_cache[8] = ($event: any) => (_ctx.updateFIeldIndex(_ctx.indexIdNumber))),
                disabled: 
              _ctx.getRuleTFtzIdentityNoDisabled || _ctx.getRuleTInterIdentityNoDisabled
            ,
                disableBackground: 
              _ctx.getRuleTFtzIdentityNoDisabled || _ctx.getRuleTInterIdentityNoDisabled
            
              }, null, 8, ["modelValue", "format", "placeholder", "error", "errorCaption", "onUpdate:modelValue", "disabled", "disableBackground"])
            ]),
            _: 1
          }, 8, ["label", "optional"]),
          _createVNode(_component_DataWrapper, {
            class: "text-xs",
            label: _ctx.getTranslationText('taxNumberLabel'),
            id: "doc-international-input-wrapper",
            optional: !_ctx.isTaxNumberRequired
          }, {
            default: _withId(() => [
              _createVNode(_component_LpInput, {
                id: "doc-international-input",
                class: "w-full",
                modelValue: _ctx.modelValue.taxNumber,
                "onUpdate:modelValue": [
                  _cache[9] || (_cache[9] = ($event: any) => (_ctx.modelValue.taxNumber = $event)),
                  _ctx.validateTaxNumber
                ],
                placeholder: _ctx.getTranslationText('taxNumberPlaceholder'),
                format: 
              (e) => (_ctx.isFtz ? _ctx.formatNomorOnly(e, true) : _ctx.formatCIPLQuantity(e))
            ,
                minLength: _ctx.isFtz ? 15 : 1,
                error: 
              !!_ctx.decideShowError(_ctx.error.taxNumberDocInternational, _ctx.indexTaxNumber)
            ,
                errorCaption: 
              _ctx.decideShowError(_ctx.error.taxNumberDocInternational, _ctx.indexTaxNumber)
            ,
                onFocus: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateFIeldIndex(_ctx.indexTaxNumber))),
                disabled: _ctx.getRuleTFtzTaxNoDisabled || _ctx.getRuleTInterTaxNoDisabled,
                disableBackground: 
              _ctx.getRuleTFtzTaxNoDisabled || _ctx.getRuleTInterTaxNoDisabled
            
              }, null, 8, ["modelValue", "placeholder", "format", "minLength", "error", "errorCaption", "onUpdate:modelValue", "disabled", "disableBackground"])
            ]),
            _: 1
          }, 8, ["label", "optional"]),
          (_ctx.isFtz)
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 1,
                class: "text-xs",
                label: _ctx.getTranslationText('shipmentStatusLabel'),
                id: "doc-international-input-wrapper",
                optional: ""
              }, {
                default: _withId(() => [
                  _createVNode(_component_CustomDropdown, {
                    id: "doc-international-input",
                    modelValue: _ctx.modelValue.shipmentStatus,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.modelValue.shipmentStatus = $event)),
                    isDisabled: _ctx.getRuleTFtzShipmentStatusDisabled,
                    disableBackground: _ctx.getRuleTFtzShipmentStatusDisabled,
                    options: 
              _ctx.accountIsNonForeign
                ? _ctx.shipmentStatusOptions
                : _ctx.shipmentStatusInterpackOptions
            ,
                    placeholder: _ctx.getTranslationText('shipmentStatusPlaceholder'),
                    selectedItem: _ctx.modelValue.shipmentStatus,
                    isFocusable: true,
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.updateFIeldIndex(_ctx.indexShipmentStatus)))
                  }, null, 8, ["modelValue", "isDisabled", "disableBackground", "options", "placeholder", "selectedItem"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("section", _hoisted_33, [
          _createVNode("div", _hoisted_34, [
            _createVNode(_component_DataWrapper, {
              class: "text-xs",
              label: _ctx.getTranslationText('supportingDocumentLabel'),
              id: "doc-international-input-wrapper",
              optional: _ctx.isFtz,
              isDefault: false
            }, null, 8, ["label", "optional"]),
            _createVNode("div", _hoisted_35, _toDisplayString(_ctx.getTranslationText("supportingDocumentSpec")), 1)
          ]),
          _createVNode("div", _hoisted_36, [
            _createVNode(_component_UploadImageTiny, {
              id: "doc-international-upload-img",
              class: {
              'supporting-document-error-box': !!_ctx.decideShowError(
                _ctx.error.idImageDocInternational,
                _ctx.indexImageIdUrl
              )
            },
              title: _ctx.getTranslationText('supportingDocumentIdLabel'),
              accept: "image/jpg, image/jpeg, image/png",
              modelValue: _ctx.modelValue.imageIdUrl,
              "onUpdate:modelValue": [
                _cache[13] || (_cache[13] = ($event: any) => (_ctx.modelValue.imageIdUrl = $event)),
                _ctx.validateImageId
              ],
              defaultImage: _ctx.imageIdUrl,
              optional: !_ctx.isIdentityImageRequired,
              maxSize: 5,
              showErrorMessage: false,
              onError: _ctx.validateImageId,
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.updateFIeldIndex(_ctx.indexImageIdUrl))),
              onUpload: _ctx.onUploadIdImage,
              onRemove: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onRemoveImage(_ctx.imageIdUrlTemp))),
              disabled: 
              _ctx.getRuleTFtzImageEmailDisabled || _ctx.getRuleTInterImageEmailDisabled
            
            }, null, 8, ["class", "title", "modelValue", "defaultImage", "optional", "onError", "onUpdate:modelValue", "onUpload", "disabled"]),
            _createVNode(_component_UploadImageTiny, {
              id: "doc-international-upload-img",
              class: {
              'supporting-document-error-box': !!_ctx.decideShowError(
                _ctx.error.taxImageDocInternational,
                _ctx.indexImageIdUrl
              )
            },
              title: _ctx.getTranslationText('supportingDocumentTaxLabel'),
              accept: "image/jpg, image/jpeg, image/png",
              modelValue: _ctx.modelValue.imageTaxUrl,
              "onUpdate:modelValue": [
                _cache[16] || (_cache[16] = ($event: any) => (_ctx.modelValue.imageTaxUrl = $event)),
                _ctx.validateImageTax
              ],
              defaultImage: _ctx.imageTaxUrl,
              optional: !_ctx.isTaxImageRequired,
              maxSize: 5,
              showErrorMessage: false,
              onError: _ctx.validateImageTax,
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.updateFIeldIndex(_ctx.indexImageTaxUrl))),
              onUpload: _ctx.onUploadTaxImage,
              onRemove: _cache[18] || (_cache[18] = ($event: any) => (_ctx.onRemoveImage(_ctx.imageTaxUrlTemp))),
              disabled: 
              _ctx.getRuleTFtzImageTaxNoDisabled || _ctx.getRuleTInterImageTaxNoDisabled
            
            }, null, 8, ["class", "title", "modelValue", "defaultImage", "optional", "onError", "onUpdate:modelValue", "onUpload", "disabled"]),
            _createVNode(_component_UploadImageTiny, {
              id: "doc-international-upload-img",
              class: {
              'supporting-document-error-box': !!_ctx.decideShowError(
                _ctx.error.packageBeforePackingImageDocInternational,
                _ctx.indexImageBeforePackingUrl
              )
            },
              title: _ctx.getTranslationText('supportingDocumentBeforePackingLabel'),
              accept: "image/jpg, image/jpeg, image/png",
              modelValue: _ctx.modelValue.imageBeforePackingUrl,
              "onUpdate:modelValue": [
                _cache[19] || (_cache[19] = ($event: any) => (_ctx.modelValue.imageBeforePackingUrl = $event)),
                _ctx.validateImageBeforePacking
              ],
              defaultImage: _ctx.iamgeBeforePackingUrl,
              optional: !_ctx.isBeforeAndAfterPackingImageRequired,
              maxSize: 5,
              showErrorMessage: false,
              onError: _ctx.validateImageBeforePacking,
              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.updateFIeldIndex(_ctx.indexImageBeforePackingUrl))),
              onUpload: _ctx.onUploadBeforePackingImage,
              onRemove: _cache[21] || (_cache[21] = ($event: any) => (_ctx.onRemoveImage(_ctx.imageBeforePackingUrlTemp))),
              disabled: 
              _ctx.getRuleTFtzImageBeforePackingDisabled ||
                _ctx.getRuleTInterImageBeforePackingDisabled
            
            }, null, 8, ["class", "title", "modelValue", "defaultImage", "optional", "onError", "onUpdate:modelValue", "onUpload", "disabled"]),
            _createVNode(_component_UploadImageTiny, {
              id: "doc-international-upload-img",
              class: {
              'supporting-document-error-box': !!_ctx.decideShowError(
                _ctx.error.packageAfterPackingImageDocInternational,
                _ctx.indexImageAfterPackingUrl
              )
            },
              title: _ctx.getTranslationText('supportingDocumentAfterPackingLabel'),
              accept: "image/jpg, image/jpeg, image/png",
              modelValue: _ctx.modelValue.imageAfterPackingUrl,
              "onUpdate:modelValue": [
                _cache[22] || (_cache[22] = ($event: any) => (_ctx.modelValue.imageAfterPackingUrl = $event)),
                _ctx.validateImageAfterPacking
              ],
              defaultImage: _ctx.imageAfterPackingUrl,
              optional: !_ctx.isBeforeAndAfterPackingImageRequired,
              maxSize: 5,
              showErrorMessage: false,
              onError: _ctx.validateImageAfterPacking,
              onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.updateFIeldIndex(_ctx.indexImageAfterPackingUrl))),
              onUpload: _ctx.onUploadAfterPackingImage,
              onRemove: _cache[24] || (_cache[24] = ($event: any) => (_ctx.onRemoveImage(_ctx.imageAfterPackingUrlTemp))),
              disabled: 
              _ctx.getRuleTFtzImageAfterPackingDisabled ||
                _ctx.getRuleTInterImageAfterPackingDisabled
            
            }, null, 8, ["class", "title", "modelValue", "defaultImage", "optional", "onError", "onUpdate:modelValue", "onUpload", "disabled"])
          ]),
          (!!_ctx.supportingDocumentErrorMessage)
            ? (_openBlock(), _createBlock("div", _hoisted_37, [
                _hoisted_38,
                _createVNode("div", _hoisted_39, _toDisplayString(_ctx.$t(_ctx.supportingDocumentErrorMessage)), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.isModalViewAll)
      ? (_openBlock(), _createBlock(_component_ModalAllCommodity, {
          key: 0,
          onClose: _cache[25] || (_cache[25] = ($event: any) => (_ctx.isModalViewAll = false)),
          onChange: _ctx.onChooseCommodity,
          clientCountry: _ctx.clientCountry
        }, null, 8, ["onChange", "clientCountry"]))
      : _createCommentVNode("", true)
  ], 64))
})